enum FileCategories {
  STATEMENT = "STATEMENT",
  MEDICARE_AU_STATEMENT = "MEDICARE_AU_STATEMENT"
}

export type FileCategory = keyof typeof FileCategories

export default FileCategories
